export function extendAppRoutingModuleRoutes(routes: any) {   
    routes[0].redirectTo = "home/results";
    //routes[routes.length - 1].redirectTo = "home/landing";

    routes[0].redirectTo = 'home/results';

    // No Login page -> Redirect to calculation Page
    routes[1].redirectTo = 'home/results';
    routes[1].pathMatch = 'full'
    delete routes[1].loadChildren;
    return routes;
}